import axios from 'axios';
import { Cookies, } from 'react-cookie';
import { sha256, } from '../../../utils/sha256';
import * as types from '../../../constant/actionTypes';
import { HOST, } from '../../../constant';

const LOGIN_TIMEOUT = 43200; // seconds

export function fetchDataError(err) {
  return {
    type: types.USER_LOGIN_API_ERROR,
    payload: {
      msg: '登入: 代號或密碼錯誤' + err.message,
    },
  };
}

export function fetchDataSuccess(response) {
  const cookies = new Cookies();
  cookies.set('_t', response.data.token, { maxAge: LOGIN_TIMEOUT, path: '/', });
  cookies.set('_c', response.data.company, { maxAge: LOGIN_TIMEOUT, path: '/', });

  return {
    type: types.USER_LOGIN_API_SUCCESS,
    payload: {
      token: response.data.token,
      company: response.data.company,
    },
  };
}

export function fetchDataRequest() {
  return {
    type: types.USER_LOGIN_API_REQUEST,
  };
}

const fetchData = (projectId, password) => {
  return (dispatch) => {
    dispatch(fetchDataRequest());
    const options = {
      method: 'POST',
      data: {
        username: projectId,
        password: sha256(password),
      },
      // url: `/data/${projectId}/login/${pass}.json`
      url: `${HOST}/saber/auth/`,
    };
    return axios(options)
      .then(json => dispatch(fetchDataSuccess(json)))
      .catch(err => dispatch(fetchDataError(err))); // PAGE_ERROR
  };
};

export default fetchData;



// WEBPACK FOOTER //
// ./src/scenes/Login/actions/login.js